import {ShieldCheck} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const PhonelinkLockIcon = createLucideIcon(ShieldCheck, 'PhonelinkLockIcon');
